import React, { createContext, useContext, useState } from 'react';

const HouseDetailsContext = createContext();

export function HouseDetailsProvider({ children }) {
    const [houseDetails, setHouseDetails] = useState({
        houseId: '',
        houseName: '',
        houseAddress: '',
    });

    return (
        <HouseDetailsContext.Provider value={{ ...houseDetails, setHouseDetails }}>
            {children}
        </HouseDetailsContext.Provider>
    );
}

export function useHouseDetails() {
    return useContext(HouseDetailsContext);
} 